import mapProps from '../scripts/utils/map-props';
import Menu from './menu';

export default mapProps(
  [
    'active',
    'collapsed',
  ],
  {
    model: {
      prop: 'active',
      event: ['change', 'update:active', 'select'],
    },
  }
)(Menu);
